import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class UserCurrencyReferenceService extends BaseReferenceService {
  constructor() {
    super('UserCurrencyReference');
  }
}
